/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';
import { formatDisplayDate } from '@/util/MomentUtils';

export default async function GetOrderPackage(orderPackageID) {
  const response = await $.soap({
    body: {
      GetOrderPackage: {
        $xmlns: 'http://dla.mil/ems/bpm/order_package',
        OrderPackageID: orderPackageID
      }
    },
    blueprintArrays: ['GetOrderPackageResponse.Response.tuple'],
    blueprint: {
      id: '$..ID',
      crsInternalUserID: '$..CRSInternalUserID',
      epcInternalUserID: '$..EPCInternalUserID',
      csFolderID: '$..CSFolderID',
      statusID: '$..StatusID',
      regionGroupID: '$..RegionGroupID',
      orderFormTypeID: '$..OrderFormTypeID',
      customerContactDate: '$..CustomerContactDate',
      customerContactDateReq: '$..CustomerContactDateReq',
      orderPkgSubmissionDateReq: '$..OrderPkgSubmissionDateReq',
      replacementDeviceCount: '$..ReplacementDeviceCount',
      awPackageID: '$..AWPackageID',
      externalUserID: '$..ExternalUserID',
      createdBy: '$..CreatedBy',
      createdOn: '$..CreatedOn',
      updatedOn: '$..UpdatedOn',
      updatedBy: '$..UpdatedBy',
      submittedOn: '$..SubmittedOn',
      epcDecisionStatusID: '$..EPCDecisionStatusID',
      epcDecisionExplanation: '$..EPCDecisionExplanation',
      crsFirstName: '$..CRSFirstName',
      crsLastName: '$..CRSLastName',
      epcFirstName: '$..EPCFirstName',
      epcLastName: '$..EPCLastName',
      formCode: '$..FormCode',
      formName: '$..FormName',
      status: '$..OrderPackageStatus',
      regionGroup: '$..RegionGroup',
      replacementPIINSPIIN: '$..ReplacementPIINSPIIN',
      popDate: '$..POPDate',
      popDateUpdatedBy: '$..POPDateUpdatedBy',
      popDateUpdatedOn: '$..POPDateUpdatedOn',
      vendorName: '$..VendorName',
      vendorEmail: '$..VendorEmail',
      vendorPhone: '$..VendorPhone',
      vendorEmailSentOn: '$..VendorEmailSentOn',
      trackerNumbers: [
        '$..GetOrderPackageResponse.Response.tuple',
        {
          name: '$.old.CustomerOrder.TrackerNumber'
        }
      ]
    }
  });
  cleanUpResponse(response);

  response.assignedCRS = response.crsFirstName ? `${response.crsFirstName} ${response.crsLastName}` : '--';
  response.assignedEPC = response.epcFirstName ? `${response.epcFirstName} ${response.epcLastName}` : '--';
  response.customerContactDate = formatDisplayDate(response.customerContactDate);
  response.customerContactDateReq = formatDisplayDate(response.customerContactDateReq);
  response.submittedOn = formatDisplayDate(response.submittedOn);
  if (response.vendorEmailSentOn) response.vendorEmailSentOn = formatDisplayDate(response.vendorEmailSentOn);
  
  return response;
}
